import api from './api';
import { Concepto, PaginatedResponse } from '../types';

class ConceptosService {
  async getConceptos(page = 1, limit = 10, search?: string): Promise<PaginatedResponse<Concepto>> {
    const params = new URLSearchParams({
      page: page.toString(),
      limit: limit.toString(),
    });
    
    if (search) {
      params.append('search', search);
    }

    const response = await api.get(`/conceptos?${params}`);
    const payload = response.data as { items: Concepto[]; total: number; page: number; totalPages: number; limit?: number };
    return {
      data: payload.items,
      total: payload.total,
      page: payload.page,
      totalPages: payload.totalPages,
      limit: payload.limit,
    };
  }

  async getConceptoById(id: number): Promise<Concepto> {
    const response = await api.get<Concepto>(`/conceptos/${id}`);
    return response.data;
  }

  async getConceptosActivos(): Promise<Concepto[]> {
    const response = await api.get<Concepto[]>('/conceptos/activos');
    return response.data;
  }

  async createConcepto(concepto: Omit<Concepto, 'id' | 'createdAt' | 'updatedAt'>): Promise<Concepto> {
    const response = await api.post<Concepto>('/conceptos', concepto);
    return response.data;
  }

  async updateConcepto(id: number, concepto: Partial<Concepto>): Promise<Concepto> {
    const response = await api.put<Concepto>(`/conceptos/${id}`, concepto);
    return response.data;
  }

  async deleteConcepto(id: number): Promise<void> {
    await api.delete(`/conceptos/${id}`);
  }
}

const conceptosService = new ConceptosService();
export default conceptosService;
